import React from 'react';

export const OfertaInvalida = React.memo((data) => {

    

    return (
        <div className="promo expirada">
                        
            <div className="titulo">No hay oferta activa para este número.</div>


            {/* {data.oferta &&
                data.oferta.map( (offer, i) => (
                    <OfertaPromo2 key={ i } oferta={offer}/>
                    )
                )
            } */}
        
        </div>
    )
})
